<template>
  <div id="student">
    <button v-if="editable" @click="onDelete" class="delete">删除</button>
    <div class="input-wrapper">
      <h3 class="title">中文名</h3>
      <div class="input" :class="{ active: state.active === 'name' }">
        <input
          v-model="form.name"
          type="text"
          placeholder="宝宝的中文名"
          @focus="state.active = 'name'"
          @blur="state.active = null"
        />
      </div>
    </div>
    <div class="input-wrapper">
      <h3 class="title">英文名</h3>
      <div class="input" :class="{ active: state.active === 'nameEng' }">
        <input
          v-model="form.nameEng"
          type="text"
          placeholder="宝宝的英文名或汉字拼音"
          @focus="state.active = 'nameEng'"
          @blur="state.active = null"
        />
      </div>
    </div>
    <div class="input-wrapper">
      <h3 class="title">年龄</h3>
      <div class="input" :class="{ active: state.active === 'age' }">
        <input
          v-model="form.age"
          type="tel"
          placeholder="宝宝几岁啦？"
          @focus="state.active = 'age'"
          @blur="state.active = null"
        />
      </div>
    </div>
    <div class="input-wrapper">
      <h3 class="title">性别</h3>
      <div class="input" :class="{ active: state.active === 'gender' }">
        <RadioGroup>
          <Radio :name="1" v-model="form.gender" label="男生">
            男生
            <i class="anyteachicon anyteach-male blue" />
          </Radio>
          <Radio :name="2" v-model="form.gender" label="女生">
            女生
            <i class="anyteachicon anyteach-female red" />
          </Radio>
        </RadioGroup>
      </div>
    </div>
    <button class="btn-primary" @click="complete">
      <span v-if="editable">保存修改</span>
      <span v-else>确认</span>
    </button>
  </div>
</template>

<script>
import Modal from "@/components/popup/Modal"
import Radio from "mand-mobile/lib-vw/radio"
import RadioGroup from "mand-mobile/lib-vw/radio-group"
import Dialog from "mand-mobile/lib-vw/dialog"

export default {
  name: "Student",
  components: {
    Modal,
    Radio,
    RadioGroup,
  },
  props: ["editable"],
  data() {
    return {
      state: {
        active: null,
        dismiss: false,
      },
      form: {
        name: "",
        nameEng: "",
        age: "",
        gender: null,
      },
      regExp: {
        age: new RegExp("^[0-9]{0,3}$"),
        name: new RegExp("^[\u4e00-\u9fa5]{0,10}$"),
        nameEng: /^[a-zA-Z\s]*$/,
      },
    }
  },
  watch: {
    "form.name": function (newVal, oldVal) {
      if (!this.regExp.name.test(newVal)) {
        this.form.name = oldVal
      }
    },
    "form.nameEng": function (newVal, oldVal) {
      if (newVal.length && !this.regExp.nameEng.test(newVal)) {
        this.form.nameEng = oldVal
      }
    },
    "form.age": function (newVal, oldVal) {
      if (!this.regExp.age.test(newVal)) {
        this.form.age = oldVal
      }
    },
    "form.gender": function (val) {
      if (val && this.state.active === "gender") {
        this.state.active = null
      }
    },
  },
  methods: {
    async delete() {
      if (!this.editable) return
      this.$toastLoading()
      const { code, msg } = await this.$api.user.DEL_STUDENT(this.editable.id)
      if (code === "1000") {
        this.$store.commit("user", msg)
        this.$toastSuccess("删除成功")
        this.$emit("complete")
      } else {
        this.$toastError(`${msg}（${code}）`)
      }
    },
    async complete() {
      if (!this.form.name || !this.form.name.length) {
        this.state.active = "name"
        return this.$toast("请填写中文名")
      }
      if (!this.form.nameEng || !this.form.nameEng.length) {
        this.state.active = "nameEng"
        return this.$toast("请填写英文名")
      }
      if (!this.form.age || !Number(this.form.age).toString().length) {
        this.state.active = "age"
        return this.$toast("请填写年龄")
      }
      if (!this.form.gender) {
        this.state.active = "gender"
        return this.$toast("请选择性别")
      }
      this.$toastLoading()
      const { code, msg } = await this.$api.user.UPDATE_STUDENT_V2({
        name: this.form.name.trim(),
        name_eng: this.form.nameEng.trim(),
        age: parseInt(this.form.age),
        gender: parseInt(this.form.gender),
        student_id: this.editable ? this.editable.id : null
      })
      if (code === "1000") {
        this.$store.commit("user", msg)
        this.$toastSuccess(this.editable ? "修改成功" : "已添加")
        return this.$emit("complete")
      }
      this.$toastError(`${msg}（${code}）`)
    },
    onDelete() {
      Dialog.confirm({
        title: "确认删除",
        content: "您真的要删除这条学生信息吗？",
        confirmText: "确认",
        cancelText: "取消",
        onConfirm: () => {
          this.delete()
        },
      })
    }
  },
  mounted() {
    if (this.editable) {
      const { age, gender, name, name_eng } = this.editable
      this.form.age = age || null
      this.form.gender = gender || null
      this.form.name = name || null
      this.form.nameEng = name_eng || null
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/components/popup/modal.scss";
@import "./style.scss";

#student {
  .md-radio {
    @include avenir();
    font-size: 1rem;
    padding: 5px 0;
  }
  .delete {
    position: absolute;
    top: 15px;
    right: 15px;
    border: none;
    padding: 0;
    color: $red;
    transition: all 0.1s;
    font-size: 0.9rem;
    &:active {
      opacity: 0.6;
    }
  }
}
</style>
